var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Map',{attrs:{"locations":_vm.location,"zoom":_vm.mapZoom,"center":_vm.coordinates && _vm.coordinates.length > 0 ? _vm.coordinates : null},on:{"click":_vm.clickHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }